import { apiFetch } from './config';

// After a DELIBERATE URL import that a model is allowed to read, extract claims
// immediately — the imported page should arrive in the Reader already
// underlined (owner 2026-07-06: "creating an object from a url should
// suggest/highlight claims"). Same idempotent, egress-gated decompose
// endpoint as the Reader CTA and the object page button; RSS refresh
// imports stay cheap on purpose (batch items decompose on first read).
// Failure is non-fatal: the page imported fine, the Reader CTA remains.
//
// Takes an ACCESS PAIR since 2026-08-08, and reads only its model half. Legacy
// tier strings still work: the two that permitted a model both do here too, and
// 'sealed' means the same thing under both vocabularies. The check is
// deliberately "not sealed" rather than "is public_ai" — a private_ai page is
// decomposed on the owner-run lane, which is the whole point of that state.
export async function decomposeImportedPage(page, access) {
  const model = typeof access === 'string' ? access : access?.model;
  if (!page?.id || model === 'sealed') return null;
  try {
    const res = await apiFetch(`/api/objects/${page.id}/decompose`, { method: 'POST' });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
